<template>
  <div class="modal-card" style="width: 100%" data-test-id="memberDetailsModal">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("RelevantMembers", { callerEntityDetails: titleString }) }}</p>
      <b-button icon-pack="fas" icon-left="times" @click="onClose" />
    </header>
    <section class="modal-card-body">
      <memberAdministrationDetails
        :membersList="membersList"
        :loading="loading"
        :showRelatedItems="false"
      />
    </section>
    <footer class="modal-card-foot">
      <b-button @click="onClose">{{ $t("Close") }}</b-button>
    </footer>
  </div>
</template>

<script setup lang="ts">
import memberAdministrationDetails from "@/components/members/memberAdministrationDetails.vue";
import type { Member } from "@/stores/app";

withDefaults(defineProps<{
  membersList: Array<Member & { memberId: number }>;
  loading: boolean;
  titleString: string;
}>(), {
  loading: false,
  titleString: '',
});

const emit = defineEmits<{
  (e: "close"): void;
}>();

const onClose = (): void => {
  emit("close");
};
</script>
